import { useQuery } from "@apollo/client";
import { toaster } from "evergreen-ui";
import { auth } from "firebase";
import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import HomePresenter from "./HomePresenter";
import { GET_HOME } from "./HomeQueries.local";
import { FiRefreshCw } from "react-icons/fi";
import { RiHandCoinFill } from "react-icons/ri";
import { FaBox } from "react-icons/fa";
import { MdStoreMallDirectory } from "react-icons/md";

interface IProps extends RouteComponentProps<any> {
  userInfo?: any;
  isAdmin: boolean;
}
const Home: React.SFC<IProps> = ({ match, isAdmin }) => {
  const { data, loading, error } = useQuery(GET_HOME, {
    variables: {
      id: auth().currentUser?.uid,
    },
  });

  const actions = [
    {
      name: "Restock/ Upgrade",
      icon: <FiRefreshCw size={18} />,
    },
    {
      name: "Monthly Maintenance",
      icon: <RiHandCoinFill size={18} />,
    },
    {
      name: "Request Shipment",
      icon: <FaBox size={18} />,
    },
    {
      name: "Mall",
      icon: <MdStoreMallDirectory size={18} />,
    },
  ];

  useEffect(() => {
    if (!loading && !data && error) {
      toaster.danger(error.message);
    }
  }, [data, loading, error]);
  return (
    <HomePresenter
      loading={loading}
      data={data}
      actions={actions}
      isAdmin={isAdmin}
    />
  );
};

export default withRouter(Home);
